module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "FMRM_TTL"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1",
    attrs: {
      "id": "fore"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/33311_Foreword"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Foreword by Dee Snider")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "id": "p1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/33311_Part1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "lspac"
  }, [_vm._v("PART I:")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("From the Cradle to the Stage")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/33311_Chapter1"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Sweet Sixteen")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/33311_Chapter2"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("The Audition")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Born to Be Bad")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("4")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Queens of Noise")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("5")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Japan")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("6")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Good-Bye, Cherie")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3",
    attrs: {
      "id": "p2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "lspac"
  }, [_vm._v("PART II:")]), _vm._v(" "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Girls Don’t Play Guitar")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("7")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Get a Real Job")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("8")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("The Makeover")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("9")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Dancin’ on the Edge")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("10")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Lita")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Lisa")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("12")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Black")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("13")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Mother")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("14")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("The Asylum")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "id": "ch015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("15")]), _c('span', {
    staticClass: "spacer_1_00"
  }), _vm._v("Living Like a Runaway")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "photo"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_PhotoInserts",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Photo Section")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "ata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_ATA",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "cre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Credits",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "cpy"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1NEXT",
    attrs: {
      "id": "atp"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/33311_ATP",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ae7a874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/33311_Contents.vue
// module id = 69
// module chunks = 0